import { LanguageSwitcher } from './LanguageSwitcher';

function Header() {
  return (
    <header className="bg-white border-b border-[#eaeecd]">
      <div className="container mx-auto py-4 px-4">
        <div className="flex items-center">
          <h1 className="text-xl font-bold text-[#006b69]">
            <a href="https://mypaperwork.ai/" target="_blank" rel="noopener noreferrer">
              mypaperwork.ai
            </a>
          </h1>
          <div className="ml-auto flex items-center space-x-4">
            <span className="text-sm text-[#36454F] hidden md:inline-block">Your Austrian visa and paperwork assistant</span>
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
